
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getAllCookieConsents } from '@/lib/actions';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export const CookieConsents = () => {
  const { data: consents = [], isLoading, error } = useQuery({
    queryKey: ['cookieConsents'],
    queryFn: getAllCookieConsents,
  });

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Cookie Consents</CardTitle>
          <CardDescription>Loading cookie consent data...</CardDescription>
        </CardHeader>
      </Card>
    );
  }

  if (error) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Cookie Consents</CardTitle>
          <CardDescription>Error loading cookie consent data</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-destructive">An error occurred while loading the data</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Cookie Consents</CardTitle>
        <CardDescription>
          View all users who have accepted or declined cookies
        </CardDescription>
      </CardHeader>
      <CardContent>
        {consents.length === 0 ? (
          <p className="text-center py-4 text-gray-500">No cookie consent data available</p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>User ID</TableHead>
                <TableHead>IP Address</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Date</TableHead>
                <TableHead>Last Updated</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {consents.map((consent) => (
                <TableRow key={consent.id}>
                  <TableCell className="font-medium">{consent.user_id || 'Anonymous'}</TableCell>
                  <TableCell>{consent.ip_address || 'Not available'}</TableCell>
                  <TableCell>
                    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium
                      ${consent.accepted ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                      {consent.accepted ? 'Accepted' : 'Declined'}
                    </span>
                  </TableCell>
                  <TableCell>
                    {new Date(consent.created_at || '').toLocaleDateString()}
                  </TableCell>
                  <TableCell>
                    {new Date(consent.updated_at || '').toLocaleDateString()}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};

export default CookieConsents;
